import Applicant from "@higher/models/Applicant";
import batchUpdate, { BatchUpdateFn, UpdateCallback } from "./batchUpdate";

export type UpdateApplicantsFn = BatchUpdateFn<Applicant>;

export const UpdateApplicants = (callback: UpdateCallback<Applicant>) =>
  batchUpdate<Applicant>("applicants", callback);

export default UpdateApplicants;
